import QuizzesService, { fixQuestion } from "@/services/QuizzesService";

export default {
    state() {
        return {
            quiz: {
                title: "",
                text: "",
                image: "",
                disciplineId: ""
            },
            quizzesData: "",
            quizFileData: "",
            selectedQuizzes: [],
            quizDataToUpdate: [],
            questionGeneratedFromIA: [],
            selectAllQuestionsState: false,
            userCanLoadMoreQuizzes: true,
            routeThatAccessedFeedbackView: null,
            notExcludedQuestions: []
        }
    },

    getters: {
        getNotExcludedQuestions: (state) => state.notExcludedQuestions,
        getRouteThatAccessedFeedbackView: (state) => state.routeThatAccessedFeedbackView,
        getUserCanLoadMoreQuizzesState: (state) => state.userCanLoadMoreQuizzes,
        getSelectAllQuestionsState: (state) => state.selectAllQuestionsState,
        getQuestionGeneratedFromIA: (state) => state.questionGeneratedFromIA,
        getQuizzesData: (state) => state.quizzesData,
        getSelectedQuizzes: (state) => state.selectedQuizzes,
        getQuizDataToUpdate: (state) => state.quizDataToUpdate
    },

    mutations: {
        setNotExcludedQuestions(state, data) {
            data && (state.notExcludedQuestions = data)
        },

        setRouteThatAccessedFeedbackView(state, data) {
            state.routeThatAccessedFeedbackView = data || null
        },

        incrementQuizzesCreatedWithOldData(state, data) {
            if (data) {
                const perPageRenderedInViews = 30
                const pageRendered = Math.ceil(state.quizzesData.length / perPageRenderedInViews)
                state.quizzesData = [...data, ...state.quizzesData]
                if (pageRendered > 0) {
                    const quizzesAmountInView = pageRendered * 30
                    state.quizzesData.length >= quizzesAmountInView && (state.quizzesData.splice(quizzesAmountInView))
                }

            }
        },

        setUserCanLoadMoreQuizzesState(state, data) {
          state.userCanLoadMoreQuizzes = data
        },


        setQuestionDataGeneratedFromIA(state, data) {
          data && (state.questionGeneratedFromIA = data)
        },

        deleteQuestion(state, data) {
          data.length > 0 && (state.quizzesData =  state.quizzesData.filter((q) => !data.includes(q.id)))
        },

        setQuestionsDocumentationURL(state, data) {
            data && (state.questionsDocumentationURL = data)
        },

        setQuizData(state, data) {
            state.quiz.name = data.name;
            state.quiz.text = data.text;
            state.quiz.image = data.image;
            state.quiz.disciplineId = data.discipline_id;
            state.quizDataToUpdate = data
        },
        resetQuiz(state) {
            state.quiz = {
                title: "",
                text: "",
                image: "",
                disciplineId: "",
            };
        },

        handleQuizzesDataPagination(state, data) {
            state.quizzesData = [...state.quizzesData, ...data]
        },

        setQuizzesData(state, data) {
            state.quizzesData = data
        },
        setQuizFileData(state, data) {
            state.quizFileData = data
        },
        selectedQuestionsManagement(state, payload) {
            state.selectAllQuestionsState = payload.selectAll
            if (!payload.selectAll && !payload.question) return state.selectedQuizzes = []
            if (payload.selectAll) return state.selectedQuizzes = state.quizzesData.map((qd) => qd.id)

            const verifyQuestionIndex = state.selectedQuizzes.findIndex((q) => q === payload.question)
            if (verifyQuestionIndex !== -1) return state.selectedQuizzes.splice(verifyQuestionIndex, 1)

            state.selectedQuizzes.push(payload.question)
        },

        saveTrueOrFalseAnswer(state, data) {
            const quizIndex = state.quizzesData.findIndex((q) => q.id === data.quizId)
            if (quizIndex !== -1) {
                state.quizzesData[quizIndex].markedAs = data.markedAs
                state.quizzesData[quizIndex].isChecked = true
            }
        },

        saveDescriptiveAnswer(state, data) {
            const quizIndex = state.quizzesData.findIndex((q) => q.id === data.quizId)
            if (quizIndex !== -1) {
                state.quizzesData[quizIndex].answer = data.answer
                state.quizzesData[quizIndex].isChecked = !!data.answer
            }
        }
    },

    actions: {
        setRouteThatAccessedFeedbackView({commit}, payload) {
            commit('setRouteThatAccessedFeedbackView', payload)
        },

        incrementQuizzesCreatedWithOldData({commit}, payload) {
            commit('incrementQuizzesCreatedWithOldData', payload)
        },

        saveDescriptiveAnswer({commit}, payload) {
            commit('saveDescriptiveAnswer', payload)
        },

        saveTrueOrFalseAnswer({commit}, payload) {
            commit('saveTrueOrFalseAnswer', payload)
        },

        setUserCanLoadMoreQuizzesState({commit}) {
          commit('setUserCanLoadMoreQuizzesState', true)
        },

        selectedQuestionsManagement({commit}, payload) {
            commit('selectedQuestionsManagement', payload)
        },

        async validateQuizPassWordTry({}, payload) {
          try {
              const response = await QuizzesService.validateQuizPassWordTry(payload)
              return response
          } catch (error) {
              return error
          }
        },

        async createQuiz({ commit }, payload) {
            try {
                const response = await QuizzesService.createQuiz(payload.quiz, payload.userToken);

                commit('resetQuiz');

                return response.data;
            } catch (error) {
                console.error('Erro ao adicionar questão:', error);

                throw new Error('Não foi possível adicionar a questão. Por favor, tente novamente.');
            }
        },

        async findQuiz({ commit }, payload) {
            try {
                const response = await QuizzesService.findQuiz(payload.quizId, payload.userToken);

                commit('setQuizData', response.data);

                return response.data;
            } catch (error) {
                console.error('Erro ao consultar questão:', error);

                throw new Error('Não foi possível consultar questão. Por favor, tente novamente.');
            }
        },

        async updateQuiz({ commit }, payload) {
            try {
                const response = await QuizzesService.updateQuiz(payload.quiz, payload.userToken);

                commit('setQuizData', response.data);

                return response.data;
            } catch (error) {
                console.error('Erro ao atualizar questão:', error);

                throw new Error('Não foi possível atualizar a questão. Por favor, tente novamente.');
            }
        },

        async deleteQuiz({ commit, dispatch }, payload) {
            try {
                const response = await QuizzesService.deleteQuiz(payload.quizId, payload.userToken);
                const errorFound = response?.errors.length > 0

                if (errorFound) {
                    dispatch('toastfy/activeErrorNotification', { text: "Questões vinculadas a questionários não podem ser deletadas!" })
                    return response
                }

                commit('deleteQuestion', [payload.quizId])
                dispatch('toastfy/activeSuccesNotification', { text: "Questão excluida com sucesso!" })


                return response
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: `Erro ao deletar questões: ${error}` })
            }
        },

        async getQuizzes({ commit, dispatch }, payload) {
            try {
                const response = await QuizzesService.getQuizzes(payload.data, payload.userToken);
                if (response.data.length === 0 && payload.incrementWithOldData) {
                    dispatch('toastfy/activeErrorNotification', { text: `Todas as questões já foram exibidas!` })
                    commit('setUserCanLoadMoreQuizzesState', false)
                    return
                }

                payload.incrementWithOldData ? commit('handleQuizzesDataPagination', response.data)
                    : commit('setQuizzesData', response.data, payload.incrementWithOldData);

                return response.data;
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            }
        },

        async generateQuizzesQuestions({commit, dispatch}, payload) {
            try {
                dispatch('setLoadingState', {loadignState: true, loadingView: 'QuizzesModule'})
                dispatch('toastfy/activeSuccesNotification', { text: "Aguarde, estamos gerando sua questão!" })
                const response = await QuizzesService.generateQuizzesQuestions(payload)
                dispatch('setQuestionToUpdateData', {...response})
            } catch (Error) {
                dispatch('toastfy/activeErrorNotification', { text: `Erro ao gerar questões: ${Error}` })
            } finally {
                dispatch('setLoadingState', {loadignState: false, loadingView: ''})
            }
        },

        async checkFile({ commit }, payload) {
            try {
                const response = await QuizzesService.checkFile(payload.data, payload.userToken);

                commit('setQuizFileData', response);

                return response;
            } catch (error) {
                console.error('Erro ao verificar arquivo:', error);

                throw error;
            }
        },

        async fixQuestion({ commit }, payload) {
            try {
                const response = await fixQuestion(payload.data, payload.userToken);

                commit('success', 'Questão corrigida com sucesso!');

                return response;
            } catch (error) {
                console.error('Erro ao corrigir questão:', error);

                throw error;
            }
        },

        async deleteMany({ commit, dispatch }, payload) {
            try {
                const response = await QuizzesService.deleteMany(payload.data, payload.userToken);
                const errorsFound = response?.errors.length > 0
                let questionsToDelete = payload.data.quizzes

                if (errorsFound) {
                    commit("setNotExcludedQuestions", response.errors)
                    dispatch('setModalData', { modalName: 'NotExcludedQuestions' })

                    const questionsNotDeleted = response.errors.map((questionError) => questionError.id)
                    questionsToDelete = questionsToDelete.filter((questionId) => !questionsNotDeleted.includes(questionId))

                    commit('selectedQuestionsManagement', { selectAll: false, question: false })
                    commit('deleteQuestion', questionsToDelete)

                    if (response.errors.length >= payload.data.quizzes) {
                        dispatch('toastfy/activeErrorNotification', { text: "Nenhuma questão foi excluida!" })
                        return
                    }

                    dispatch('toastfy/activeSuccesNotification', { text: 'Algumas das questões selecionadas foram excluidas!'  })
                    return
                }

                dispatch('toastfy/activeSuccesNotification', { text: "Todas as questões foram excluidas com sucesso!" })
                commit('deleteQuestion', questionsToDelete)
                return response
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: `Erro ao deletar questões: ${error}` })
            }
        },

        async exportQuizzes({ commit, dispatch }, payload) {
            try {
                dispatch('setLoadingState', {loadignState: true, loadingView: 'QuizzesModule'})
                dispatch('toastfy/activeSuccesNotification', { text: "Exportando questões!" }, { root: true })
                const response = await QuizzesService.exportQuizzes(payload)
                dispatch('toastfy/activeSuccesNotification', { text: "Questões Exportadas!" }, { root: true })
                return response;
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error }, { root: true })
            } finally {
                dispatch('setLoadingState', {loadignState: false})
            }
        },

        async downloadQuestionDocs({commit, dispatch}, payload) {
            try {
                dispatch('setLoadingState', {loadignState: true, loadingView: 'QuizzesModule'})
                dispatch('toastfy/activeSuccesNotification', { text: "Aguarde, estamos gerando suas questões!" }, { root: true })
                const response = await QuizzesService.downloadQuestionDocs(payload)
                commit('selectedQuestionsManagement', { selectAll: false, question: false })
                dispatch('toastfy/activeSuccesNotification', { text: "Questões Geradas!" }, { root: true })
                return response
            } catch (Error) {
                dispatch('toastfy/activeErrorNotification', { text: Error }, { root: true })
            } finally {
                dispatch('setLoadingState', {loadignState: false})
            }
        },

        async evalueteQuestion({commit, dispatch}, payload) {
            try {
                await QuizzesService.evalueteQuestion(payload)
                dispatch('toastfy/activeSuccesNotification', { text: 'Avaliação Registrada!' })
                return true
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error }, { root: true })
            }
        }
    }
}
